import Vue from "vue";
import dayjs from "dayjs";
import 'dayjs/locale/de'

dayjs.extend(require('dayjs/plugin/localizedFormat'));
dayjs.extend(require('dayjs/plugin/duration'));
dayjs.extend(require('dayjs/plugin/dayOfYear'));

dayjs.locale('de')
Vue.moment = dayjs;
Vue.prototype.$moment = dayjs;

Vue.filter('datetime', (date) => dayjs(date).format('lll'));
Vue.filter('date', (date) => dayjs(date).format('ll'));
Vue.filter('time', (date) => dayjs(date).format('LTS'));
Vue.filter('date_format', (date, format) => dayjs(date).format(format));
